// Pulse-employee active-survey RPCs.
import { supabase } from '@/lib/supabase';

export type SurveyAnchor = {
  id: string;
  name: string;
  description: string | null;
  sort_order: number;
  scale_type: 'likert_5' | string;
  scale_labels: Record<string, string> | null;
  answered_value: number | null;
};

export type SurveyProgress =
  | { active: false }
  | {
      active: true;
      survey_id: string;
      survey_topic: string;
      total_anchors: number;
      answered: number;
      next_anchor_id: string | null;
      anchors: SurveyAnchor[];
    };

export async function mySurveyProgress(orgId: string) {
  const { data, error } = await supabase.rpc('my_survey_progress', { _org_id: orgId });
  return { data: data as SurveyProgress | null, error };
}

export async function submitAnchorResponse(
  orgId: string,
  surveyId: string,
  anchorId: string,
  value: number,
) {
  return supabase.rpc('submit_anchor_response', {
    _org_id: orgId,
    _survey_id: surveyId,
    _anchor_id: anchorId,
    _value: value,
  });
}

export async function summarizeConversation(conversationId: string) {
  try {
    await supabase.functions.invoke('summarize-conversation', {
      body: { conversation_id: conversationId },
    });
  } catch (e) {
    console.warn('[charles] summarize-conversation failed (non-fatal)', e);
  }
}

/** Sweep: summarize any prior conversations of this user that have turns but no summary. */
export async function sweepPendingSummaries() {
  try {
    await supabase.functions.invoke('summarize-conversation', {
      body: { sweep: true },
    });
  } catch (e) {
    console.warn('[charles] sweep summaries failed (non-fatal)', e);
  }
}
